let blacklist = [
  'aggregate',
  'appregion',
  'backgroundimage',
  'backgroundsize',
  'classname',
  'clippath',
  'cursor',
  'data',
  'fontweight',
  'format',
  'formatout',
  'goto',
  'isdisabled',
  'isfragment',
  'ismodal',
  'onclickusediv',
  'onsubmit',
  'overflow',
  'overflowx',
  'overflowy',
  'pagebreakinside',
  'perspective',
  'required',
  'rotatez',
  'scalez',
  'shadowspread',
  'stream',
  'texttransform',
  'transformorigin',
  'transformoriginz',
  'transition',
  'translatez',
  'type',
  'userselect',
  'validate',
  'iskeyboardavoidingview',
  'issafeareaview',
  'scrolltoend',
]

export default (node, parent, state) =>
  !blacklist.includes(node.name.toLowerCase())
